import { NavLink, Outlet, Link } from 'react-router-dom';
import './Layout.css';

type NavItem = { to: string; label: string; end?: boolean };

const navItems: NavItem[] = [
  { to: '/', label: 'HOME', end: true },
  { to: '/company', label: '회사소개' },
  { to: '/products', label: '제품소개' },
  { to: '/online-request', label: '온라인 요청서' },
  { to: '/deliveries', label: '납품실적' },
];

function Layout() {
  return (
    <div className="app-layout">
      <header className="app-header">
        <div className="app-header__inner">
          <Link to="/" className="app-brand" aria-label="홈으로 이동">
            <img src={`${process.env.PUBLIC_URL}/img/logo.png`} alt="" />
          </Link>
          <nav className="app-nav" aria-label="주 메뉴">
            <ul className="app-nav-list">
              {navItems.map(({ to, label, end }) => (
                <li key={to}>
                  <NavLink
                    to={to}
                    end={end}
                    className={({ isActive }) =>
                      isActive ? 'app-nav-link app-nav-link--active' : 'app-nav-link'
                    }
                  >
                    {label}
                  </NavLink>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </header>
      <main className="app-main">
        <Outlet />
      </main>
      <footer className="app-footer" role="contentinfo">
        <div className="app-footer__inner">
          <div className="app-footer__brand">
            <strong className="app-footer__name">세진건설안전(주)</strong>
            <p className="app-footer__tagline">건설안전용품 납품 전문업체, 청정소화약제 대리점(비젼엔지니어링)</p>
          </div>
          <div className="app-footer__meta">
            <p>주소: 서울특별시 노원구 동일로242길 41,3층(상원빌딩)</p>
            <p>전화: 02-904-3356 · 팩스: 02-3296-3306</p>
            <p>이메일: sejin3356@naver.com</p>
          </div>
          <p className="app-footer__copy">
            © {new Date().getFullYear()} 세진건설안전. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}

export default Layout;
